export default __webpack_public_path__ + "static/media/vancouvercanucksLG.69a48d24.png";